import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { faCheck } from "@fortawesome/pro-duotone-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// One Previous-chats row: a teal check on the chat you're in, the name, when
// it was last active, and a ⋯ that shows on hover.
export const ChatRow: FC<{ current: boolean; children: ReactNode }> = ({
  current,
  children,
}) => (
  <div className="group flex items-center gap-[9px] px-3 py-2 hover:bg-slate-50">
    <span className="flex w-3 shrink-0 justify-center text-xs text-indigo-600">
      {current && <FontAwesomeIcon icon={faCheck} />}
    </span>
    {children}
  </div>
);

export const ChatRowName: FC<{
  current: boolean;
  onClick(): void;
  children: ReactNode;
}> = ({ current, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(
      "min-w-0 flex-1 cursor-pointer truncate text-left text-[12.5px]",
      current ? "font-semibold text-slate-900" : "text-slate-700",
    )}
  >
    {children}
  </button>
);

export const ChatRowMeta: FC<{ children: ReactNode }> = ({ children }) => (
  <span className="shrink-0 text-[11px] whitespace-nowrap text-slate-400">
    {children}
  </span>
);

export const ChatRowActions: FC<{ children: ReactNode }> = ({ children }) => (
  <span className="relative shrink-0 opacity-0 group-hover:opacity-100 focus-within:opacity-100 has-data-open:opacity-100">
    {children}
  </span>
);
